import { plural } from '@cian/utils';

export const formatFloors = (floors: number): string => {
  return `${floors} ${plural(floors, ['этаж', 'этажа', 'этажей'])}`;
};
